import { OwcTypography, OwcInput, OwcIcon } from '@one/react';
import styles from './ConfirmInput.module.css';

/**
 * "Type the exact value to confirm" guard for destructive actions.
 *
 * Controlled: the parent owns `value` and decides enablement by comparing
 * `value` to `confirmText`; this component only renders the input.
 *
 * @param {object} props
 * @param {string} props.confirmText                 the value the user must type
 * @param {string} props.value                       current input value
 * @param {(value: string) => void} props.onChange
 * @param {React.ReactNode} [props.title='Confirm']
 * @param {string} [props.className]
 */
export default function ConfirmInput({
  confirmText,
  value,
  onChange,
  title = 'Confirm',
  className = '',
}) {
  // Trim to match the execute gate, so the checkmark and the enabled button agree.
  const matched = String(value).trim() === confirmText && confirmText !== '';

  return (
    <div className={`${styles.wrapper} ${className}`.trim()}>
      <div className={styles.copy}>
        <OwcTypography variant="subtitle2" className={styles.title}>
          {title}
        </OwcTypography>
        <OwcTypography variant="caption" className={styles.hint}>
          Type <strong className={styles.code}>{confirmText}</strong> to enable the action.
        </OwcTypography>
      </div>
      <OwcInput
        variant="outlined"
        size="small"
        rounded
        aria-label={`Type ${confirmText} to confirm`}
        value={value}
        placeholder={confirmText}
        onInput={(e) => onChange?.(e.target.value)}
        no-clear-icon
        className={styles.input}
      >
        {matched && (
          <OwcIcon
            slot="suffix"
            name="circle_confirm"
            family="filled"
            className={styles.matchIcon}
          />
        )}
      </OwcInput>
    </div>
  );
}
